import React, { useEffect, useMemo, useState } from 'react';
import ServiceScheduleShiftForm, {
	REPEAT_INTERVAL_OPTIONS,
	ServiceScheduleShiftFormValues,
} from '../ServiceScheduleShiftForm/ServiceScheduleShiftForm';
import { Moment } from 'moment';
import { useServiceScheduleContext } from '../../../WorkplaceMember/Services/ServiceScheduleContext';
import useServiceSchedulesHelper from '../../Hooks/useServiceSchedulesHelper';
import { ServiceScheduleType } from '../../../../graphql/graphql';
import { RepeatInterval } from '../../Enums/RepeatInterval.enum';
import useTranslation from '../../../../Hooks/useTranslation';
import Loading from '../../../../Components/Loading';

interface Props {
	selectedDate: Moment;
	resourceId: string;
	onSuccess: () => void;
}

const ServiceScheduleCreate: React.FC<Props> = ({
	selectedDate,
	resourceId,
	onSuccess,
}) => {
	const { workplaceMembersSelectValues, workplaceId } =
		useServiceScheduleContext();
	const { createServiceSchedule } = useServiceSchedulesHelper();
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const [defaultValues, setDefaultValues] = useState<Record<string, any>>({});

	const handleCreate = async (values: ServiceScheduleShiftFormValues) => {
		setIsLoading(true);
		await createServiceSchedule({
			workplaceId,
			values: values as ServiceScheduleShiftFormValues,
		});
		setIsLoading(false);
		onSuccess();
	};

	const repeatIntervalDefaultValue = REPEAT_INTERVAL_OPTIONS.find(
		item => item.value === RepeatInterval.NEVER,
	);

	useEffect(() => {
		setIsLoading(true);
		const workplaceMemberValue = workplaceMembersSelectValues.find(
			workplaceMember => workplaceMember.userId === resourceId,
		);

		setDefaultValues({
			date: selectedDate,
			workplaceMember: workplaceMemberValue ? workplaceMemberValue : undefined,
			workingTime: ServiceScheduleType.Shift,
			repeatInterval: repeatIntervalDefaultValue
				? {
						label: t(repeatIntervalDefaultValue?.label),
						value: repeatIntervalDefaultValue?.value,
				  }
				: undefined,
		});
		setTimeout(() => {
			setIsLoading(false);
		}, 100);
	}, [resourceId]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<ServiceScheduleShiftForm
			onSubmit={handleCreate}
			defaultValues={defaultValues}
		/>
	);
};

export default ServiceScheduleCreate;
